<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';
export default {
  name: 'StudentWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: 'StudentModule',
  }),
};
</script>
